import React from 'react'
import App from './App'
import { ContextProvider } from '@monorepo/service'
import { ApmProvider } from '@monorepo/service'

const Page = () => (
  <ApmProvider>
    <ContextProvider>
      <App />
    </ContextProvider>
  </ApmProvider>
)

export default Page
